import config from '../../../config/config.json';

export interface SubMenuItem {
    label: string;
    url: string;
}

export const mySecurePracticeSubMenuItems = (locationId: number): SubMenuItem[] => {
    return [
        {
            label: 'Secure Mail',
            url: `${config.pbhs.url}securemail${config.pbhs.queryParams}${locationId}`
        },
        {
            label: 'ADA TV',
            url: `${config.pbhs.url}ada-tv${config.pbhs.queryParams}${locationId}`
        },
        {
            label: 'Log In to MySecurePractice',
            url: `${config.mySecurePractice.url}${config.mySecurePractice.queryParams}${locationId}`
        }
    ];
};

export const pbhsWebisteAdminSubMenuItems = (_locationId: number): SubMenuItem[] => {
    return [
        {
            label: 'Website Design',
            url: 'https://www.revenuewell.com/dental-digital-marketing-services/dental-website-design?utm_source=mp&utm_medium=inapp&utm_campaign=navigation_bar'
        },
        {
            label: 'Search Engine Optimization',
            url: 'https://www.revenuewell.com/dental-digital-marketing-services/dental-seo?utm_source=mp&utm_medium=inapp&utm_campaign=navigation_bar'
        },
        {
            label: 'PPC/Google Advertising',
            url: 'https://www.revenuewell.com/dental-digital-marketing-services/dental-ppc-advertising?utm_source=mp&utm_medium=inapp&utm_campaign=navigation_bar'
        },
        {
            label: 'Social Media Marketing',
            url: 'https://www.revenuewell.com/features-social-media?utm_source=mp&utm_medium=inapp&utm_campaign=navigation_bar'
        }
    ];
};

